import { Component, computed, input, signal } from '@angular/core';
import { AnimateOpenDirective } from '../../../../../../shared/directives/animate-open.directive';
import { TimeFormatPipe } from '../../../../../../shared/pipes/time-format.pipe';
import { capitaliseText } from '../../../../../../shared/utils/formatting';

export type ContactHours = {
  openingTime: string;
  closingTime: string;
};

export type Schedule = {
  monday: ContactHours;
  tuesday: ContactHours;
  wednesday: ContactHours;
  thursday: ContactHours;
  friday: ContactHours;
  saturday: ContactHours;
  sunday: ContactHours;
};

@Component({
  selector: 'app-contact-hours',
  imports: [TimeFormatPipe, AnimateOpenDirective],
  templateUrl: './contact-hours.component.html',
  styleUrl: './contact-hours.component.scss',
})
export class ContactHoursComponent {
  contactHours = input.required<Schedule | undefined>();

  open = signal(false);

  private viewModel = computed(() => {
    return {
      open: this.open(),
      contactHours: Object.entries(this.contactHours() || {}).map(([day, times]) => {
        return {
          day: capitaliseText(day),
          openingTime: times?.openingTime,
          closingTime: times?.closingTime,
          isClosed: times.openingTime === '00:00:00' && times.closingTime === '00:00:00',
        };
      }),
    };
  });

  get vm() {
    return this.viewModel();
  }
}
